import { render } from "./MobileNavbar.vue?vue&type=template&id=4533bed2"
import script from "./MobileNavbar.vue?vue&type=script&lang=ts"
export * from "./MobileNavbar.vue?vue&type=script&lang=ts"
script.render = render

export default script